import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

export type Props = {
	isContentExpanded: boolean;
	onExpand: () => void;
	onCollapse: () => void;
};

const ContentSectionExpander = ({ isContentExpanded, onExpand, onCollapse }: Props) => {
	const { formatMessage } = useIntl();
	const handleExpand = (event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		onExpand();
		fireUIAnalytics(analyticsEvent, 'showRelatedIssues');
	};

	const handleCollapse = (event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		onCollapse();
		fireUIAnalytics(analyticsEvent, 'hideRelatedIssues');
	};

	const renderShowIssuesButton = () => (
		<Button
			aria-label={formatMessage(messages.newShow)}
			appearance="subtle-link"
			// @TODO JIV-16016 migrate data-test-id
			data-test-id="smart-related-issues-panel.ui.header.expander.expand-button"
			spacing="default"
			iconBefore={<ChevronDownIcon label="" size="large" />}
			onClick={handleExpand}
			interactionName="auto-generated.jira-smart-related-issues-panel.ui.header.expander.button"
		/>
	);

	const renderHideIssuesButton = () => (
		<Button
			aria-label={formatMessage(messages.hide)}
			appearance="subtle-link"
			spacing="default"
			iconBefore={<ChevronUpIcon label="" size="large" />}
			onClick={handleCollapse}
			interactionName="auto-generated.jira-smart-related-issues-panel.ui.header.expander.button1"
		/>
	);

	return isContentExpanded ? renderHideIssuesButton() : renderShowIssuesButton();
};

export default ContentSectionExpander;
